import { Separator, Text } from 'react-aria-components';
import { twMerge } from 'tailwind-merge';

import type { IconProps } from 'src/types/common';

export interface TextLabelProps {
  label: string;
  prefix?: string;
  description?: string;
  Icon?: IconProps;
  className?: string;
  separator?: boolean;
}

const TextLabel = ({
  label,
  Icon,
  prefix,
  description,
  className = '',
  separator = false,
}: TextLabelProps) => {
  return (
    <>
      <div
        className={twMerge(
          'flex items-center gap-2 text-sm font-medium text-surface-alt-75 whitespace-nowrap',
          className
        )}
      >
        {Icon ? (
          <Icon aria-hidden="true" className="text-xl text-surface-alt-75" />
        ) : null}
        <Text>
          {prefix ? (
            <strong className="inline-block font-semibold mr-1">
              {prefix}
            </strong>
          ) : null}
          {label}
        </Text>
        {separator ? (
          <Separator className="border-surface-ghost w-full ml-1" />
        ) : null}
      </div>
      {description ? (
        <Text className="text-md text-surface-alt-90 font-semibold">
          {description}
        </Text>
      ) : null}
    </>
  );
};

export default TextLabel;
